module.exports = __webpack_public_path__ + "static/media/work (3).d7a29698.jpg";